import React from 'react';

export type ModelWorkspaceTarget = 'operational' | 'revit' | 'settings';

interface ModelWorkspaceSelectorProps {
  mode: Exclude<ModelWorkspaceTarget, 'settings'>;
  revitAvailable: boolean;
  onSelect: (target: ModelWorkspaceTarget) => void;
  className?: string;
  compact?: boolean;
}

export const ModelWorkspaceSelector: React.FC<ModelWorkspaceSelectorProps> = ({
  mode,
  revitAvailable,
  onSelect,
  className = '',
  compact = false,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onSelect(event.target.value as ModelWorkspaceTarget);
  };

  return (
    <label className={`flex items-center gap-2 border border-[#dfe3e6] bg-[#f7f8f8] ${
      compact ? 'h-8 min-w-[152px] rounded-xl px-2.5 py-1' : 'h-11 min-w-[164px] rounded-2xl px-3 py-1.5'
    } ${className}`}>
      <i className="fa-solid fa-cubes text-[11px] text-[#08777d]" />
      <span className="sr-only">공간 트윈 화면 선택</span>
      <select
        value={mode}
        onChange={handleChange}
        title={revitAvailable
          ? '운영 3D, Revit 검토 또는 모델 설정으로 이동'
          : 'Revit 모델이 아직 준비되지 않았습니다. Revit 검토를 선택하면 모델 설정으로 이동합니다.'}
        className="min-w-0 flex-1 cursor-pointer bg-transparent text-[11px] font-semibold text-[#3e444b] outline-none"
      >
        <option value="operational">화면 · 운영 3D</option>
        <option value="revit">화면 · Revit 검토</option>
        <option value="settings">관리 · 모델 설정</option>
      </select>
    </label>
  );
};
